export const STATUS = {
    CLEARANCE: 'CLEARANCE',
    ERROR: 'ERROR',
    INPUT: 'INPUT',
    KNOCKOUT: 'KNOCKOUT',
    LOADING: 'LOADING',
    QUOTE: 'QUOTE',
    RESULT: 'RESULT',
    SEARCH: 'SEARCH',
    SUCCESS: 'SUCCESS',
    CREATING: 'CREATING',
    DRAFT: 'DRAFT'
};

export const OKTA_VERSIONS = {
    V1: 'v1', // Original version of Okta
    V2: 'v2' // Represents new Okta Identity Engine
}

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

/**
 * PRESIGN_BUCKET_LOOKUP_KEYS contains the key names used in the /OE/API/S3_BUCKET_LOOKUP 
 * parameter store variable. The parameter store variable is used to define S3 buckets that 
 * should allow for presigned URLs for file access.
 */
export const PRESIGN_BUCKET_LOOKUP_KEYS = {
    ASSETS_PDFS: 'assets_pdfs'
}

export const BASE_COMMISSION = 17.5;
